const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaChecklistResposta: [],
	listaModelo: [],
	QRCode: null,
	listaCliente: [],
	listaGrupo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'CERTIFICADO_EMISSAO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CERTIFICADO_EMISSAO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'CERTIFICADO_EMISSAO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'CERTIFICADO_EMISSAO_CHECKLIST_RESPOSTA_SELECT_LISTADO':
            return {
				...state,
				listaChecklistResposta: action.payload.data
			};
		
		case 'CERTIFICADO_EMISSAO_MODELO_SELECT_LISTADO':
            return {
				...state,
				listaModelo: action.payload.data
			};

		case 'CERTIFICADO_EMISSAO_QRCODE_SELECT_LISTADO':			
			return {
				...state,
				QRCode: action.payload.data
			};

		case 'CERTIFICADO_EMISSAO_CLIENTE_SELECT_LISTADO':			
			return {
				...state,
				listaCliente: action.payload.data
			};

		case 'CERTIFICADO_EMISSAO_GRUPO_SELECT_LISTADO':			
			return {
				...state,
				listaGrupo: action.payload.data
			};

        default:
            return state;
    }
}
